import {
  IBrandState,
  IBrandInfoState,
  IInitialBrandState,
  IBrandTenantState,
} from 'interfaces/brand.interface';
import * as BrandTypes from './brand.types';

export type TbrandDispatchReducer =
  | {
      type: typeof BrandTypes.GET_BRAND_INFO;
      payload: IBrandInfoState;
    }
  | {
      type: typeof BrandTypes.SELECT_TENANT;
      payload: IBrandTenantState | null;
    }
  | {
      type: typeof BrandTypes.SHARE_DATA_WITH_BRAND;
      payload: {
        datashareId: string;
        value: boolean;
      };
    }
  | {
      type: typeof BrandTypes.SET_IS_LOADING;
      payload: boolean;
    };

export default function brandReducer(
  state: IInitialBrandState,
  action: TbrandDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case BrandTypes.GET_BRAND_INFO: {
      const getBrandInfo: IInitialBrandState = {
        ...state,
        brand: { ...(state.brand as IBrandState), info: payload },
      };
      return getBrandInfo;
    }

    case BrandTypes.SELECT_TENANT: {
      if (!payload) return state;
      const selectTenant: IInitialBrandState = {
        ...state,
        brand: { ...(state.brand as IBrandState), tenantSelected: payload },
      };
      return selectTenant;
    }

    case BrandTypes.SHARE_DATA_WITH_BRAND: {
      if (!state.brand || !state.brand.tenantSelected) return state;
      const getBrandPointsOfSale: IInitialBrandState = {
        ...state,
        brand: {
          ...state.brand,
          tenantSelected: {
            ...state.brand.tenantSelected,
            pointsOfSale: state.brand.tenantSelected.pointsOfSale.map((item) => {
              if (item.datashare_id === payload.datashareId) {
                return {
                  ...item,
                  data_share: payload.value,
                };
              }
              return item;
            }),
          },
        },
      };
      return getBrandPointsOfSale;
    }

    case BrandTypes.SET_IS_LOADING: {
      const setIsLoading: IInitialBrandState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    default:
      return state;
  }
}
